import type { HTMLAttributes, ReactNode } from 'react'
import { cx } from './cx'
import s from './Pill.module.css'

export type Tone = 'good' | 'warn' | 'critical' | 'neutral' | 'brand'

export interface PillProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: Tone
  children: ReactNode
}

/**
 * REST PROPS REACH THE ELEMENT (#2406), the fix `EmptyState` and `CountPill`
 * already carry. This took `tone`, `title` and `children` and dropped
 * everything else — silently, because a hyphenated JSX attribute is not
 * checked against a component's prop type. Two console call sites had been
 * passing a `data-testid` into nothing (`ResponsePanel`'s state, the tender
 * workspace's overdue count), and a state word that another control names
 * with `aria-describedby` could not be a Pill at all, because its `id` never
 * arrived. `RelationshipWorkspace`'s "Already linked" / "Inactive" words are
 * that case, and are this control now.
 */
export function Pill({ tone = 'neutral', className, children, ...rest }: PillProps) {
  return <span className={cx(s.pill, s[tone], className)} {...rest}>{children}</span>
}
